export default "__VITE_ASSET__Wat8ahSv__"